/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description:  Manual input for mission phases 
Author: Deimos Space UK

Version: 1.0
*/

import React from 'react'
import { Row, Col, Form } from 'react-bootstrap';
import style from '../MissionPhases.module.css'
function ManualInput(props) {

   

    return (
        <div>
            <Row className={style.rowForm}>
                <Col xs={6} md={3} >
                    <Form.Group className={style.manualInput} controlId="startDate">
                        <Form.Label style={{ color: '#003247' }}>Start Date</Form.Label>
                        <Form.Control
                            disabled={props.disabled}

                            type="date"
                            isInvalid={(props.step3[props.index][props.phase][props.indexPhase].start_epoch > props.step3[props.index][props.phase][props.indexPhase].end_epoch && props.step3[props.index][props.phase][props.indexPhase].end_epoch !== '') || (props.phase !== 'launchPhase' && props.step3[props.index]['launchPhase'][0].start_epoch > props.step3[props.index][props.phase][props.indexPhase].start_epoch)}
                            value={(props.step3[props.index][props.phase][props.indexPhase].start_epoch)}
                            onChange={e => { props.changeStartDate(e, props.index, props.phase, props.indexPhase) }} />

                    </Form.Group>
                </Col>
                <Col xs={6} md={3} >

                    <Form.Group className={style.manualInput} controlId="endDate">
                        <Form.Label style={{ color: '#003247' }}>End Date</Form.Label>
                        <Form.Control
                            disabled={props.disabled}
                            isInvalid={(props.step3[props.index][props.phase][props.indexPhase].start_epoch > props.step3[props.index][props.phase][props.indexPhase].end_epoch && props.step3[props.index][props.phase][props.indexPhase].start_epoch !== '') || (props.phase !== 'launchPhase' && props.step3[props.index]['launchPhase'][0].start_epoch > props.step3[props.index][props.phase][props.indexPhase].start_epoch)}
                            value={(props.step3[props.index][props.phase][props.indexPhase].end_epoch)}
                            onChange={e => props.changeEndDate(e, props.index, props.phase, props.indexPhase)} type="date" />
                    </Form.Group>
                </Col >
            </Row>
            <Row className={style.rowForm}>
                <Col xs={6} md={3} xl={2}>
                    <Form.Group className={style.manualInput} controlId="semiMajorAxis">
                        <Form.Label style={{ color: '#003247' }}>Semi major axis [km]</Form.Label>
                        <Form.Control
                            isInvalid={(isNaN(parseFloat(props.step3[props.index][props.phase][props.indexPhase].keplerian.sma)) && props.step3[props.index][props.phase][props.indexPhase].keplerian.sma !== '') || (props.step3[props.index][props.phase][props.indexPhase].keplerian.sma < 6400 && props.step3[props.index][props.phase][props.indexPhase].keplerian.sma !== '') || props.step3[props.index][props.phase][props.indexPhase].keplerian.sma > 100000}
                            disabled={props.disabled}
                            value={props.step3[props.index][props.phase][props.indexPhase].keplerian.sma}
                            onChange={e => props.changeSemiMajorAxis(e, props.index, props.phase, props.indexPhase)} />
                    </Form.Group>
                </Col>
                <Col xs={6} md={3} xl={2}>
                    <Form.Group className={style.manualInput} controlId="eccentricity">
                        <Form.Label style={{ color: '#003247' }}>Eccentricity</Form.Label>
                        <Form.Control
                            isInvalid={(isNaN(props.step3[props.index][props.phase][props.indexPhase].keplerian.eccentricity) && props.step3[props.index][props.phase][props.indexPhase].keplerian.eccentricity !== '') || props.step3[props.index][props.phase][props.indexPhase].keplerian.eccentricity < 0 || props.step3[props.index][props.phase][props.indexPhase].keplerian.eccentricity >= 1}
                            disabled={props.disabled}
                            value={props.step3[props.index][props.phase][props.indexPhase].keplerian.eccentricity}
                            onChange={e => props.changeEccentricity(e, props.index, props.phase, props.indexPhase)} />
                    </Form.Group>
                </Col>
                <Col xs={6} md={3} xl={2}>
                    <Form.Group className={style.manualInput} controlId="inclination">
                        <Form.Label style={{ color: '#003247' }}>Inclination [deg]</Form.Label>
                        <Form.Control
                            isInvalid={(isNaN(props.step3[props.index][props.phase][props.indexPhase].keplerian.inclination) && props.step3[props.index][props.phase][props.indexPhase].keplerian.inclination !== '') || props.step3[props.index][props.phase][props.indexPhase].keplerian.inclination < 0 || props.step3[props.index][props.phase][props.indexPhase].keplerian.inclination > 180}
                            disabled=
                            {props.disabled}
                            value={props.step3[props.index][props.phase][props.indexPhase].keplerian.inclination}
                            onChange={e => props.changeInclination(e, props.index, props.phase, props.indexPhase)} />
                    </Form.Group>
                </Col>
                <Col xs={6} md={4} xl={2}>
                    <Form.Group className={style.manualInput} controlId="longitudeOfAscendingNode">
                        <Form.Label style={{ color: '#003247' }}>Right ascension of the ascending node [deg]</Form.Label>
                        <Form.Control
                            isInvalid={(isNaN(props.step3[props.index][props.phase][props.indexPhase].keplerian.raan) && props.step3[props.index][props.phase][props.indexPhase].keplerian.raan !== '') || props.step3[props.index][props.phase][props.indexPhase].keplerian.raan < 0 || props.step3[props.index][props.phase][props.indexPhase].keplerian.raan > 360}
                            disabled={props.disabled}
                            value={props.step3[props.index][props.phase][props.indexPhase].keplerian.raan}
                            onChange={e => props.changeLongitudeOfAscendingNode(e, props.index, props.phase, props.indexPhase)} />
                    </Form.Group>
                </Col>

                <Col xs={6} md={4} xl={2}>
                    <Form.Group className={style.manualInput} controlId="argumentOfPeriapsis">
                        <Form.Label style={{ color: '#003247' }}>Argument of periapsis [deg]</Form.Label>
                        <Form.Control
                            isInvalid={(isNaN(props.step3[props.index][props.phase][props.indexPhase].keplerian.argument_perigee) && props.step3[props.index][props.phase][props.indexPhase].keplerian.argument_perigee !== '') || props.step3[props.index][props.phase][props.indexPhase].keplerian.argument_perigee < 0 || props.step3[props.index][props.phase][props.indexPhase].keplerian.argument_perigee > 360}
                            disabled={props.disabled}
                            value={props.step3[props.index][props.phase][props.indexPhase].keplerian.argument_perigee}
                            onChange={e => props.changeArgumentOfPeriapsis(e, props.index, props.phase, props.indexPhase)} />
                    </Form.Group>
                </Col>
                <Col xs={6} md={3} xl={2}>
                    <Form.Group className={style.manualInput} controlId="inclination">
                        <Form.Label style={{ color: '#003247' }}>Mean anomaly [deg]</Form.Label>
                        <Form.Control
                            isInvalid={(isNaN(props.step3[props.index][props.phase][props.indexPhase].keplerian.mean_anomaly) && props.step3[props.index][props.phase][props.indexPhase].keplerian.mean_anomaly !== '') || props.step3[props.index][props.phase][props.indexPhase].keplerian.mean_anomaly < 0 || props.step3[props.index][props.phase][props.indexPhase].keplerian.mean_anomaly > 360}
                            disabled={props.disabled}
                            value={props.step3[props.index][props.phase][props.indexPhase].keplerian.mean_anomaly}
                            onChange={e => props.changeMeanAnomaly(e, props.index, props.phase, props.indexPhase)} />
                    </Form.Group>
                </Col>
            </Row>

        </div>
    )
}

export default ManualInput